export const updateProductGroupProducts = (productGroupById, handler, ...additionalHandlerParams) => {
    const newProductGroupItemsList = {};
    Object.keys(productGroupById).map(key => {
        newProductGroupItemsList[key] = handler(productGroupById[key], ...additionalHandlerParams);
    });
    return Object.assign(Object.assign({}, productGroupById), newProductGroupItemsList);
};
